'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseLayoutIndexesHierarchies = exports.parseSeriesIndexesHierarchies = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var registerParsedIndexes = function registerParsedIndexes(_ref, register) {
  var isSameSerie = _ref.isSameSerie,
      parsed = (0, _objectWithoutProperties3.default)(_ref, ['isSameSerie']);

  var merged = R.mergeWith(function (a, b) {
    return R.append(a || [], b);
  }, parsed, register);
  return (0, _extends3.default)({}, merged, { isSameSerie: isSameSerie });
};

var parseSerieIndexesHierarchies = function parseSerieIndexesHierarchies(serieIndexes, previousSerie, dimensions) {
  var defaultIsSameSerie = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  return R.addIndex(R.reduce)(function (acc, _valueIndex, dimensionIndex) {
    if (R.is(Array, _valueIndex)) {
      var previous = R.isEmpty(previousSerie) ? {} : R.map(R.nth(dimensionIndex), previousSerie);
      var parsed = parseSerieIndexesHierarchies(_valueIndex, previous, R.pathOr([], [dimensionIndex, 'dimensions'], dimensions), acc.isSameSerie);
      return registerParsedIndexes(parsed, acc);
    }
    var valueIndex = Math.abs(_valueIndex);
    var parents = R.pathOr([], [dimensionIndex, 'values', valueIndex, 'parents'], dimensions);
    var previousIndex = acc.isSameSerie ? R.pipe(R.path(['indexes', dimensionIndex]), function (i) {
      return R.isNil(i) ? -1 : Math.abs(i);
    })(previousSerie) : -1;
    var previousRegisteredIndexes = acc.isSameSerie ? R.pathOr(new _set2.default(), ['registeredIndexes', dimensionIndex], previousSerie) : new _set2.default();
    var registeredIndexes = new _set2.default(previousRegisteredIndexes);

    var _R$reduce = R.reduce(function (_acc, i) {
      if (previousRegisteredIndexes.has(i)) {
        return R.over(R.lensProp('presentParentsIndexes'), function (p) {
          return R.isNil(p) ? [i] : R.append(i, p);
        }, _acc);
      } else if (i > previousIndex) {
        registeredIndexes.add(i);
        return R.over(R.lensProp('missingParentsIndexes'), function (m) {
          return R.isNil(m) ? [i] : R.append(i, m);
        }, _acc);
      }
      return _acc;
    }, {}, parents),
        presentParentsIndexes = _R$reduce.presentParentsIndexes,
        missingParentsIndexes = _R$reduce.missingParentsIndexes;

    registeredIndexes.add(valueIndex);
    return registerParsedIndexes({ parentsIndexes: presentParentsIndexes, missingIndexes: missingParentsIndexes, registeredIndexes: registeredIndexes, isSameSerie: acc.isSameSerie && valueIndex === previousIndex }, acc);
  }, { parentsIndexes: [], missingIndexes: [], registeredIndexes: [], isSameSerie: defaultIsSameSerie }, serieIndexes);
};

var parseSeriesIndexesHierarchies = function parseSeriesIndexesHierarchies(seriesIndexes, dimensions) {
  return R.reduce(function (acc, serieIndexes) {
    var previousSerie = R.last(acc) || {};

    var _parseSerieIndexesHie = parseSerieIndexesHierarchies(serieIndexes, previousSerie, dimensions),
        isSameSerie = _parseSerieIndexesHie.isSameSerie,
        parsed = (0, _objectWithoutProperties3.default)(_parseSerieIndexesHie, ['isSameSerie']);

    return R.append(R.assoc('indexes', serieIndexes, parsed), acc);
  }, [], seriesIndexes);
};

exports.parseSeriesIndexesHierarchies = parseSeriesIndexesHierarchies;
var parseLayoutIndexesHierarchies = exports.parseLayoutIndexesHierarchies = function parseLayoutIndexesHierarchies(layoutIndexes, layout) {
  var header = parseSeriesIndexesHierarchies(layoutIndexes.header, layout.header);
  var sections = R.pipe(R.transpose, function (_ref2) {
    var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
        _sections = _ref3[0],
        _sectionsRows = _ref3[1];

    if (R.isNil(_sections)) {
      return [];
    }
    var sections = parseSeriesIndexesHierarchies(_sections, layout.sections);
    var sectionsRows = R.map(function (rows) {
      return parseSeriesIndexesHierarchies(rows, layout.rows);
    }, _sectionsRows);
    return R.transpose([sections, sectionsRows]);
  })(layoutIndexes.sections);

  return { header: header, sections: sections };
};